export const SCHOOL_CARD_GRADIENT_OVERLAY_CLASSNAME =
  'before:absolute before:inset-0 before:rounded-t-2xl before:bg-gradient-to-b before:from-transparent before:to-[rgb(var(--text-primary)/1)]'
